<div class="container-fluid mt-4 p-2 p-lg-3 p-xxl-4" style=" min-width: 350px; min-height: 72vh; overflow: hidden;">
  <div class="row justify-content-center align-items-center">
    <div class="col-12 col-md-8 text-center">
      <label class="searchLabel">
        <span *ngIf="view_allsystems_domain$ | async">
          {{"CUSTOMER.DOMAIN_PERMISSIONS" | translate}}
        </span>
        <span *ngIf="!(view_allsystems_domain$ | async)">
          {{"CUSTOMER.TITLE" | translate}}
        </span>

      </label>
    </div>

    <div [formGroup]="searchBarForm" class="col-12 col-md-10 col-lg-8 col-xl-6 text-center mb-5 mt-3">
      <label class="form-label" for="searchAutocomplete">
        {{"CUSTOMER.AUTOCOMPLETE" | translate}}</label>
      <input type="text" matInput [matAutocomplete]="searchAutocomplete" class="form-control" id="searchAutocomplete"
        formControlName="searchAutocomplete" placeholder="{{'CUSTOMER.AUTOCOMPLETEINFO' | translate}}"
        [class.is-invalid]="searchBarForm.get('searchAutocomplete')?.invalid && submitted">
      <mat-autocomplete #searchAutocomplete="matAutocomplete" [displayWith]="displaySearchName">
        <mat-option *ngFor="let option of filteredSearch$ | async" [value]="option"
          (click)="goToCustomer(option.system)">
          <div>
            {{option.title}}
          </div>
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="col-12">
      <app-customer-table></app-customer-table>
    </div>
  </div>
</div>
